import React from "react";

const Play = () => {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 21 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5 10.268C20.8333 11.0378 20.8333 12.9623 19.5 13.7321L3.75 22.8253C2.41667 23.5951 0.75 22.6329 0.75 21.0933V2.90673C0.75 1.36713 2.41667 0.404882 3.75 1.17468L19.5 10.268Z"
        fill="white"
      />
    </svg>
  );
};

export default Play;
